/* Fashion CITY — 색상 목록 한 곳에 모음 (견적 마법사용)
   ★ 색을 추가/삭제하려면 이 파일만 고치면 됩니다.
     GARMENT : 무지 제품(옷·모자·가방) 색상
     EMB     : 자수 실 색상  ← 상품 페이지 쪽은 assets/fc-po-places.js 의 FCPO_EMB
     PUFF    : 3D 퍼프 색상
     HUES    : 풀컬러 인쇄 CMYK 차트의 기준 색 [이름, C, M, Y, K]
*/
window.FC_COLORS = {
  GARMENT: [
    ['Black', 'rgb(20,20,20)'], ['White', 'rgb(252,252,250)'], ['Heather Grey', 'rgb(185,183,178)'],
    ['Charcoal', 'rgb(62,62,62)'], ['Navy', 'rgb(30,42,68)'], ['Royal', 'rgb(27,63,174)'],
    ['Red', 'rgb(200,16,46)'], ['Burgundy', 'rgb(107,31,46)'], ['Forest Green', 'rgb(30,66,48)'],
    ['Sand', 'rgb(217,199,167)'], ['Mustard', 'rgb(201,162,39)'], ['Pink', 'rgb(232,169,188)']
  ],
  EMB: [
    ['Black', 'rgb(17,17,17)'], ['Dark Grey', 'rgb(74,74,74)'], ['Grey', 'rgb(154,154,154)'],
    ['White', 'rgb(255,255,255)'], ['Off White', 'rgb(244,240,230)'], ['Beige', 'rgb(217,199,167)'],
    ['Putty', 'rgb(184,169,146)'], ['Brown', 'rgb(107,74,47)'], ['Dark Brown', 'rgb(63,42,26)'],
    ['Red', 'rgb(200,16,46)'], ['Burgundy', 'rgb(109,26,45)'], ['Orange', 'rgb(242,101,34)'],
    ['Gold', 'rgb(200,164,48)'], ['Lemon Yellow', 'rgb(244,224,77)'], ['Pink', 'rgb(240,78,152)'],
    ['Light Pink', 'rgb(244,184,200)'], ['Purple', 'rgb(107,63,160)'], ['Navy', 'rgb(30,42,68)'],
    ['Royal', 'rgb(27,63,174)'], ['Blue', 'rgb(47,111,191)'], ['Light Blue', 'rgb(157,198,232)'],
    ['Dark Green', 'rgb(18,73,43)'], ['Green', 'rgb(46,139,69)'], ['Olive', 'rgb(107,107,50)'],
    ['Sage', 'rgb(168,184,154)'], ['Mint', 'rgb(168,230,201)'], ['Neon Green', 'rgb(157,255,43)']
  ],
  PUFF: [
    ['Baby Pink', 'rgb(246,198,208)'], ['Beige', 'rgb(220,201,168)'], ['Brown', 'rgb(107,74,47)'],
    ['Blue', 'rgb(43,93,191)'], ['Dark Green', 'rgb(18,73,43)']
  ],
  HUES: [
    ['Red', 0, 100, 100, 0], ['Orange', 0, 60, 100, 0], ['Yellow', 0, 15, 100, 0],
    ['Lime', 40, 0, 100, 0], ['Green', 85, 10, 100, 10], ['Teal', 85, 20, 40, 0],
    ['Cyan', 100, 0, 0, 0], ['Blue', 100, 70, 0, 0], ['Violet', 75, 90, 0, 0],
    ['Magenta', 0, 100, 0, 0], ['Pink', 0, 70, 20, 0], ['Brown', 35, 60, 80, 25]
  ],
  TINTS: [1, 0.72, 0.46, 0.22],
  NEUTRALS: [[0,0,0,100],[0,0,0,75],[0,0,0,50],[0,0,0,25],[0,0,0,10],[0,0,0,0]],
  QTY: ['6 – 11', '12 – 24', '25 – 49', '50 – 99', '100 – 249', '250 – 499', '500 +']
};